import { TripPayload } from 'store/trips/trips.types'

export function hasTransportTasks(tripTasks: TripPayload[]): boolean {
  return tripTasks.some(
    (task) => task.type === 'PICKUP' || task.type === 'DELIVERY'
  )
}
